export const MAZDA_PORTAL_INTEGRATION_CODE = 'MAZDA_PORTAL';
